const sanitizeLogArgument = (value) => {
  if (value instanceof Error) return value.message;
  if (value && typeof value === 'object') return '[details omitted]';
  return value;
};

/**
 * 운영 브라우저 콘솔에 API payload, 토큰, 사용자 데이터가 노출되지 않게 한다.
 * 오류와 경고의 텍스트 메시지는 남겨 최소한의 진단 가능성은 유지한다.
 */
export const configureProductionLogging = () => {
  if (process.env.NODE_ENV !== 'production') return;

  const originalError = console.error.bind(console);
  const originalWarn = console.warn.bind(console);

  console.log = () => {};
  console.debug = () => {};
  console.error = (...args) => originalError(...args.map(sanitizeLogArgument));
  console.warn = (...args) => originalWarn(...args.map(sanitizeLogArgument));
};

export default configureProductionLogging;
